<template>
  <div class="loader" :class="{ absolute: absolute }">
    <v-progress-circular
      class="absolute-center"
      indeterminate
      color="primary"
    ></v-progress-circular>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    absolute: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.loader {
  &.absolute {
    position: absolute;
    z-index: 8888;
    background: #ffffffb8;
    height: 100%;
  }
  min-height: 300px;
  width: 100%;
  position: relative;
  .absolute-center {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
  }
}
</style>
